import React, {useContext,useEffect,useState} from 'react'
import {Button, FormHelperText, Box ,Switch,FormGroup,FormControlLabel,Select,makeStyles ,InputLabel,MenuItem,FormControl,RadioGroup,Radio,FormLabel} from "@material-ui/core";
import Axios from 'axios'
import {Autocompletar} from '../../../componentes/MUI/Autocompletar'
import {MuiSelect} from '../../../componentes/MUI/MuiSelect'
import { AlertDialog } from '../../../componentes/MUI/AlertDialog';
import Aceptaciones1raCredencial from '../../../componentes/Aceptaciones1raCredencial';

export const Documentos = ({documento,setDocumento,lecturas,setLecturas})=>{

return  <AlertDialog 
        open={documento} 
        titulo={'Vista de lectura e impresión del documento'} 
        fullWidth={true}
        maxWidth={'md'}
        procesarCancelar={() => setDocumento(null)}
      >
        <Aceptaciones1raCredencial 
          tipo={documento} 
          objLecturas={{lecturas, setLecturas}} 
          instancia='lectura'
        />
      </AlertDialog>
}


